import type { DeleteStatus, HydrateFile } from '@magicdoorinc/ui';

const deletedStatus = 'deleted' as DeleteStatus;

export interface FileDiffResult {
  newFiles: HydrateFile[];
  deletedFileIds: string[];
  keptFiles: HydrateFile[];
}

export interface RemoveHydrateFileResult {
  files: HydrateFile[];
  revokedIdOrUrl?: string;
}

export const parseFilesFromAPIToUploaderDefaultFileList = (files?: Array<{ id: string; name: string }>): HydrateFile[] | undefined => {
  return files?.map<HydrateFile>((file) => ({
    idOrUrl: file.id,
    name: file.name,
  }));
};

export const removeHydrateFileAtIndex = (files: HydrateFile[], index: number): RemoveHydrateFileResult => {
  const target = files[index];
  if (target == null) {
    return { files };
  }

  if (target.rawFile != null) {
    return {
      files: files.toSpliced(index, 1),
      revokedIdOrUrl: target.idOrUrl.startsWith('blob:') ? target.idOrUrl : undefined,
    };
  }

  return {
    files: files.with(index, {
      ...target,
      deleted: deletedStatus,
    }),
  };
};

export const visibleHydrateFiles = (files: HydrateFile[]): HydrateFile[] => {
  return files.filter((file) => file.deleted !== deletedStatus);
};

export const billFileRowActions = (file: HydrateFile): Array<'download' | 'delete'> => {
  return file.rawFile == null ? ['download', 'delete'] : ['delete'];
};

export const canSelectHydrateFiles = (files: HydrateFile[]): boolean => {
  return visibleHydrateFiles(files).some((file) => file.rawFile == null);
};

export const diffHydrateFiles = (files: HydrateFile[]): FileDiffResult => {
  return {
    newFiles: files.filter((file) => file.rawFile != null && file.deleted !== deletedStatus),
    deletedFileIds: files.filter((file) => file.rawFile == null && file.deleted === deletedStatus).map((file) => file.idOrUrl),
    keptFiles: files.filter((file) => file.rawFile == null && file.deleted !== deletedStatus),
  };
};

export const revokeLocalHydrateFileUrls = (files: HydrateFile[] | undefined) => {
  files?.forEach((file) => {
    if (file.rawFile != null && file.idOrUrl.startsWith('blob:')) {
      URL.revokeObjectURL(file.idOrUrl);
    }
  });
};
